import script from "./ExpandSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpandSection.vue?vue&type=script&setup=true&lang=js"

import "./ExpandSection.vue?vue&type=style&index=0&id=1318dd74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1318dd74"]])

export default __exports__